/**
 * Classroom resources API – all endpoints used by classroom resources management.
 * Base path: /admin/classroom (classroom resources routes mounted in backend organization routes).
 *
 * All endpoints return the standard shape:
 * - Success: { success: true, statusCode, message, data }
 * - Error: thrown with message from backend (response: { success: false, statusCode, message, error: { message } })
 * Use response.data for payload (e.g. response.data.resources, response.data.pagination, or single resource object for create/update).
 */
import {
  POST,
  UPLOAD_FILE,
} from "../../apiController";

const CLASSROOM_RESOURCES = '/admin/classroom';

// ==================== CLASSROOM RESOURCES ====================

// Create classroom resource
export const createClassroomResource = (data) => {
  return UPLOAD_FILE(`${CLASSROOM_RESOURCES}/create_classroom_resource`, data);
};

// Get classroom resources
export const getClassroomResources = (data) => {
  return POST(`${CLASSROOM_RESOURCES}/get_classroom_resources`, data);
};

export const getClassroomResourceById = (data) => {
  return POST(`${CLASSROOM_RESOURCES}/resource/details`, data);
};

// Update classroom resource
export const updateClassroomResource = (data) => {
  return UPLOAD_FILE(`${CLASSROOM_RESOURCES}/update_classroom_resource`, data);
};

// Delete classroom resource
export const deleteClassroomResource = (data) => {
  return POST(`${CLASSROOM_RESOURCES}/delete_classroom_resource`, data);
};

// Toggle resource status
export const toggleResourceStatus = (data) => {
  return POST(`${CLASSROOM_RESOURCES}/toggle_resource_status`, data);
};
